import { useState } from "react";
import { FoundationsCopy } from "../Types/FoundationsTypes";

const CopyIcon = (props: FoundationsCopy) => {
  const [checked, setChecked] = useState(false);
  const { width = 24, height = 24 } = props;

  const copyToClipboard = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.stopPropagation();
    navigator.clipboard.writeText(props.copyText);

    // show check icon
    setChecked(true);

    // revert back after 1.5s
    setTimeout(() => {
      setChecked(false);
    }, 1500);
  };

   if (!props.alwaysShow && !props.copyText.trim()) return null;


  // SVG paths for copy and check icons from Feather
  const copyIconSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
  );

  const checkIconSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#02add7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );

  return (
    <span
      title="Copy to Clipboard"
      className="foundations-copy"
      style={{
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        pointerEvents: "auto",
        marginLeft: 8,
        visibility: props.alwaysShow ? "visible" : props.copyText.trim() ? "visible" : "hidden",
      }}
      onClick={copyToClipboard}
    >
            {checked ? checkIconSvg : copyIconSvg}
    </span>
  );
};

export { CopyIcon };
